import { useEffect } from 'react';
import { SEO } from './landingCopy';
import { getCanonicalOrigin } from './landingConfig';

// Route-scoped metadata: applied while the landing page is mounted and removed/restored on unmount, so share,
// shop, library and signed-in routes never carry the marketing canonical or Open Graph tags.
// Without a known canonical origin (previews, localhost) no canonical/og:url/og:image is announced at all.
export const applyLandingSeo = (doc, origin) => {
  const previousTitle = doc.title;
  const created = [];
  const restored = [];
  const setMeta = (attr, key, content) => {
    let el = doc.head.querySelector(`meta[${attr}="${key}"]`);
    if (el) {
      restored.push([el, el.getAttribute('content')]);
    } else {
      el = doc.createElement('meta');
      el.setAttribute(attr, key);
      doc.head.appendChild(el);
      created.push(el);
    }
    el.setAttribute('content', content);
  };

  doc.title = SEO.title;
  setMeta('name', 'description', SEO.description);
  setMeta('property', 'og:type', 'website');
  setMeta('property', 'og:locale', 'nl_NL');
  setMeta('property', 'og:site_name', 'Zoea');
  setMeta('property', 'og:title', SEO.title);
  setMeta('property', 'og:description', SEO.description);

  let link = null;
  let previousHref = null;
  let linkCreated = false;
  if (origin) {
    setMeta('property', 'og:url', `${origin}/`);
    setMeta('property', 'og:image', `${origin}${SEO.ogImagePath}`);
    setMeta('property', 'og:image:alt', SEO.ogImageAlt);
    setMeta('name', 'twitter:card', 'summary_large_image');
    link = doc.head.querySelector('link[rel="canonical"]');
    if (link) {
      previousHref = link.getAttribute('href');
    } else {
      link = doc.createElement('link');
      link.setAttribute('rel', 'canonical');
      doc.head.appendChild(link);
      linkCreated = true;
    }
    link.setAttribute('href', `${origin}/`);
  }

  return () => {
    doc.title = previousTitle;
    created.forEach((el) => el.remove());
    restored.forEach(([el, content]) => el.setAttribute('content', content ?? ''));
    if (link) {
      if (linkCreated) link.remove();
      else if (previousHref !== null) link.setAttribute('href', previousHref);
    }
  };
};

export const useLandingSeo = () => {
  useEffect(() => applyLandingSeo(document, getCanonicalOrigin()), []);
};
